import { QueryClient } from "@tanstack/react-query";

/**
 * Query keys that all reflect operator-flagged "updates required" state —
 * invalidated together whenever a key party is added, edited, or removed so
 * the key-parties list, the onboarding status (flags/comments), and the
 * pending-actions badge stay in sync.
 */
export const UPDATES_REQUIRED_QUERY_KEYS = [
  "key-parties",
  "onboarding",
  "pending-actions",
];

export function invalidateKeyPartiesQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: (query) =>
      UPDATES_REQUIRED_QUERY_KEYS.includes(query.queryKey[0] as string),
  });
}
